// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

export const useCredentialUserService: () => UseQueryResult<
  TemplateContract<UserService> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();
  return useQueryWithOffset({
    select: (data: TemplateContract<UserService>[]) =>
      data.find((d) => d.payload.operator === operator && d.payload.user === party) || null,
    queryKey: ['queryCredentialUserService', operator, party],
    queryFn: async (_, offset) => {
      return ledgerApi.query(offset, UserService);
    },
  });
};
